
var downloads = {
    objectUrls: {},

    fromBase64File: function (base64File, fileName, mimeType) {
        var link = document.createElement('a');
        link.download = fileName;
        link.href = 'data:' + mimeType + ';base64,' + base64File;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    openFileInNewTab: function (array, type, owner) {
        var file = new Blob([array], { type: type });
        var fileURL = URL.createObjectURL(file);
        var openedWindow = window.open(fileURL, '_blank');

        if (!openedWindow) {
            URL.revokeObjectURL(fileURL);
            return;
        }

        if (owner) {
            if (!this.objectUrls[owner]) {
                this.objectUrls[owner] = [];
            }
            this.objectUrls[owner].push(fileURL);
        }
    },

    revokeObjectUrls: function (owner) {
        var urls = this.objectUrls[owner] || [];
        urls.forEach(function (url) {
            URL.revokeObjectURL(url);
        });
        delete this.objectUrls[owner];
    }
};
